export default "__VITE_ASSET__72FPpj0m__"